<template>
  <span class="relative inline-flex items-center gap-1 group/def" :class="align === 'left' ? 'justify-start' : 'justify-end'">
    <span>{{ label }}<slot /></span>
    <FontAwesomeIcon
      v-if="definition || reason"
      :icon="['fas', 'circle-info']"
      class="text-gray-300 group-hover/def:text-sky-600"
      style="font-size: 9px;"
    />
    <span
      v-if="definition || reason"
      class="pointer-events-none absolute top-full z-30 mt-1.5 hidden w-64 group-hover/def:block"
      :class="align === 'left' ? 'left-0' : 'right-0'"
      role="tooltip"
    >
      <span class="block rounded-md bg-gray-900 px-2.5 py-2 text-left text-xs font-normal leading-snug text-white shadow-lg whitespace-normal">
        <span class="block font-semibold">{{ label }}</span>
        <span v-if="definition" class="mt-0.5 block text-gray-200">{{ definition }}</span>
        <span v-if="reason" class="mt-1 block text-amber-300">{{ reason }}</span>
      </span>
    </span>
  </span>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'OperationsColumnHeader',
  components: { FontAwesomeIcon },
  props: {
    label: { type: String, required: true },
    definition: { type: String, default: '' },
    reason: { type: String, default: '' },
    align: { type: String, default: 'right' },
  },
};
</script>
